exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Header_Header_32k1I {\n  \n}\n", ""]);

// exports
exports.locals = {
	"Header": "Header_Header_32k1I"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]_[local]_[hash:base64:5]!./src/components/pages/Header.css
// module id = 1150
// module chunks = 1